// @core/api/endpoints/subscription/set_subscription_resume.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetSubscriptionResumeRequest,
  SubscriptionResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Resume subscription
 * Resumes a paused subscription. Billing restarts immediately and access is restored. Optionally allows changing to a different plan on resume.
 */
export async function SetSubscriptionResume(
  subscription_id: string,
  data: SetSubscriptionResumeRequest,
  options?: RequestOptions
): Promise<SubscriptionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/resume`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.post<SubscriptionResponse>(requestPath, data, requestOptions);
}
